export default __webpack_public_path__ + "static/media/pmpe.417eba56.svg";